import React from 'react';
import { Form, Space, Input, InputNumber } from 'antd';
import { MinusCircleOutlined } from '@ant-design/icons';
import apis from '../../../../../apis';

const AddResourceItem = (props) => {
  const { minusLine, item = {} } = props;
  return (
    <div style={{ marginTop: '20px' }}>
      <Space>
        <Form.Item
          name={['erp', item.flag]}
          validateTrigger="onBlur"
          rules={[
            {
              validator: (_, val) => {
                return new Promise((resolve, reject) => {
                  if (!val) {
                    return reject(new Error('不能为空！'));
                  } else {
                    apis.validateErp(val).then((res) => {
                      if (res.ret !== '0') {
                        return reject(new Error('输入的erp无效！'));
                      } else {
                        return resolve();
                      }
                    });
                  }
                });
              },
            },
          ]}
          style={{ width: '138px' }}
        >
          <Input placeholder="请输入erp" />
        </Form.Item>
        <Form.Item
          validateTrigger="onBlur"
          name={['resourceNum', item.flag]}
          rules={[
            {
              validator: (_, val) => {
                return new Promise((resolve, reject) => {
                  if (!val) {
                    return reject(new Error('不能为空！'));
                  } else {
                    if (val % 1 !== 0) {
                      return reject(new Error('请输入正整数！'));
                    } else {
                      return resolve();
                    }
                  }
                });
              },
            },
          ]}
          style={{ width: '138px', marginLeft: '30px' }}
        >
          <InputNumber placeholder="请输入资源数" min={1} />
        </Form.Item>
        <Form.Item name={['accountId', item.flag]} initialValue={item.accountId}>
          <Input style={{ display: 'none' }} />
        </Form.Item>
        <div className="resource-num">-</div>
        <MinusCircleOutlined className="minus-line-icon" onClick={() => minusLine(item.flag)} />
      </Space>
    </div>
  );
};

export default AddResourceItem;
